import {IntRange} from "./IntRange";

export class IntSequence {
    private sequence: IntRange[] = [];

    constructor(private length: number) {
        this.length = Math.round(length);
    }

    add(entry: number): void {

        if(entry > this.length) {
            throw new Error("Entry can not exceed IntSequence length.")
        }

        entry = Math.round(entry);
        this.sequence.push(new IntRange(entry, entry));
        this.sequence.sort(this.sorter);
        this.merge();
    }

    addRange(start: number, end: number): void {
        if(end > this.length) {
            throw new Error("Range end can not exceed IntSequence length.")
        }

        start = Math.round(start);
        end = Math.round(end);
        this.sequence.push(new IntRange(start, end));
        this.sequence.sort(this.sorter);
        this.merge();
    }

    getEmptySlots(): IntRange[] {
        let i = 0;
        const emptySlots: IntRange[] = [];

        const firstEntry = this.sequence[0];
        if(firstEntry && firstEntry.start > 0) {
            emptySlots.push(new IntRange(0, firstEntry.start));
        }

        while(this.sequence.length > i + 1) {
            const lowerEntry = this.sequence[i];
            const higherEntry = this.sequence[i + 1];

            if(higherEntry && lowerEntry && higherEntry.start - lowerEntry.end > 1) {
                emptySlots.push(new IntRange(lowerEntry.end, higherEntry.start));
            }
            i++;
        }

        const lastEntry = this.sequence[this.sequence.length - 1];

        if(lastEntry && lastEntry.end < this.length) {
            emptySlots.push(new IntRange(lastEntry.end, this.length));
        }

        return emptySlots;
    }

    getEntries(): IntRange[] {
        return this.sequence;
    }

    /**
     *
     * Note, array must be sorted.
     *
     * */
    private merge(): void {
        let i = 0;

        while(this.sequence.length > i + 1) {

            const lowerEntry = this.sequence[i];
            const lowerIndex = i;
            const higherIndex = i + 1;

            const higherEntry = this.sequence[higherIndex];

            if(lowerEntry && higherEntry && (lowerEntry.intersects(higherEntry) || lowerEntry.isAdjacent(higherEntry))) {
                const mergedEntry = lowerEntry.merge(higherEntry);
                this.sequence.splice(lowerIndex, 2, mergedEntry);
            } else {
                i++;
            }
        }
    }

    private sorter = (entry: IntRange, entry2: IntRange) => {
        if(entry.start < entry2.start) {
            return -1;
        }
        if(entry.start > entry2.start) {
            return 1;
        }
        return 0;
    }
}
